import { Capacitor } from '@capacitor/core';

// Platform detection - uses Capacitor API for reliable native detection
export function isNative(): boolean {
  if (typeof window === 'undefined') return false;
  return Capacitor.isNativePlatform();
}

/** True only on iOS native builds (iPhone AND iPad). */
export function isIOSNative(): boolean {
  if (typeof window === 'undefined') return false;
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
}
